module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-4.3ac055c5.mp3";